var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlamme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.605,
    height: 33.399,
    viewBox: "0 0 22.605 33.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 20.418,
    height: 32.053,
    fill: "#f37e72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_252",
    "data-name": "Groupe 252",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 0, 1.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_251",
    "data-name": "Groupe 251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1128",
    "data-name": "Trac\\xE9 1128",
    d: "M12.295,1.446c-.15.252-.3.5-.458.749-.356.554-.76,1.121-1.271,1.783C9.548,5.294,8.411,6.577,7.31,7.817c-1.242,1.4-2.525,2.844-3.659,4.37a25.653,25.653,0,0,0-1.468,2.177A17.892,17.892,0,0,0,1.011,16.69,12.78,12.78,0,0,0,0,21.782,11.184,11.184,0,0,0,.313,24.3a9.749,9.749,0,0,0,.793,2.127,9.937,9.937,0,0,0,2.723,3.288,10.98,10.98,0,0,0,3.825,1.94,11.107,11.107,0,0,0,2.13.371c.254.02.514.031.771.031a10.188,10.188,0,0,0,1.314-.086,9.835,9.835,0,0,0,2.121-.5,9.383,9.383,0,0,0,1.988-1,9.63,9.63,0,0,0,1.768-1.506,11,11,0,0,0,.837-1.04,9.769,9.769,0,0,0,.9-1.533,9.359,9.359,0,0,0,.868-3.082,12.1,12.1,0,0,0-.065-2.992,31.777,31.777,0,0,0-.955-4.153c-.069-.25-.139-.5-.208-.757-.178-.525-.355-1.05-.508-1.583a12.378,12.378,0,0,1-.469-2.235,7.253,7.253,0,0,1-.037-1.037c.005-.126.013-.252.025-.378l-.01.006.01-.007h0a3.068,3.068,0,0,0-.366.31c-.116.116-.226.235-.336.357a5.99,5.99,0,0,1-.511.517,2.933,2.933,0,0,1-.457.327,1.7,1.7,0,0,1-.418.174,1.082,1.082,0,0,1-.345.035.958.958,0,0,1-.329-.083,1.016,1.016,0,0,1-.262-.174,1.838,1.838,0,0,1-.158-.166q-.051-.046-.1-.1a1.657,1.657,0,0,1-.235-.342A.265.265,0,0,0,14.611,11a3.119,3.119,0,0,1-.214-.4,5.166,5.166,0,0,1-.3-1.142,10.8,10.8,0,0,1-.006-1.887,12.694,12.694,0,0,0,.019-1.644,9.41,9.41,0,0,0-.258-1.415l-.068-.291c-.082-.355-.172-.753-.245-1.164-.087-.351-.161-.707-.215-1.066A8.426,8.426,0,0,1,13.219.515c0-.172.012-.345.029-.515a13.5,13.5,0,0,0-.953,1.446",
    transform: "translate(0)",
    fill: "#f37e72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlamme);
export default __webpack_public_path__ + "static/media/flamme.f263064cfd49fc8b77dbd9a2ed3129c7.svg";
export { ForwardRef as ReactComponent };